import { useBreakpoints as vueUseBreakpoints } from '@vueuse/core'

import config from '@/config'

export const useBreakpoints = () => {
  const breakpoints = vueUseBreakpoints(config.breakpoints)

  return {
    isSmallMobile: breakpoints.smaller('sm'), // <480px (small mobile devices).
    isMobile: breakpoints.smaller('md'), // <768px.
    isTablet: breakpoints.between('md', 'lg'), // Between 768px and 1024px.
    isMobileOrTablet: breakpoints.smaller('lg'), // <1024px.
    isLaptop: breakpoints.between('lg', 'xl'), // Between 1024px and 1366px.
    isDesktop: breakpoints.greaterOrEqual('xl'), // ≥1366px.
  }
}
